import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import AvDateStore from './../../store/av-date.store'
import MaxAvDateStore from './../../store/max-av-date.store'
import SalesTrackerStore from './../../store'
import { MDBContainer, MDBAlert, MDBIcon, MDBBtn, MDBCol, MDBCollapse, MDBRow } from 'mdb-react-ui-kit'
import moment from 'moment'
import { UIDatePickerInput } from './../../../../components/forms/form-fields'
import UserProfileService from './../../../../shared/services/UserProfile.service'

import './AvDate.component.scss'

const MAX_AV_DATE = moment().toDate(),
  MIN_AV_DATE = moment().subtract(180, 'days').toDate()

const toDate = dateStr => {
  if (dateStr) {
    if (typeof dateStr === 'string') return moment(`${dateStr}`.split('T').shift()).toDate()
    if (typeof dateStr === 'object') return dateStr
  }
}

export default observer(({ disabled }) => {
  const isStaff = UserProfileService.isA(['internal-admin', 'internal-staff', 'agency-owner', 'system-admin'], true),
    [avDate, setAvDate] = useState(null),
    { enableBackdate } = MaxAvDateStore,
    { determineMinimumAvDate, minDate, maxDate } = AvDateStore,
    isEditPage = window.location.href?.includes('edit'),
    policyAvDate = SalesTrackerStore.Policy?.get('av_date'),
    policyId = SalesTrackerStore.Policy?.id()

  const isDisabled = () => {
    if (disabled) return true

    if (!SalesTrackerStore.clientType) return true

    if (SalesTrackerStore.clientType === 'group' && !SalesTrackerStore.Policy.get('client_group_id')) return true

    return false
  }

  const onAvDateChange = value => {
    if (value) {
      let valueStr = JSON.parse(JSON.stringify(value)).split('T').shift()
      if (valueStr !== SalesTrackerStore.Policy.get('av_date')) {
        SalesTrackerStore.Policy.set('av_date', valueStr)
        setAvDate(value)
      }
    }
  }

  const getMinDate = () => {
    if (minDate || MIN_AV_DATE) {
      let m = minDate || MIN_AV_DATE
      return m && typeof m === 'object' && isStaff ? m.setFullYear(m.getFullYear() - 1) : m
    }

    return minDate || MIN_AV_DATE
  }

  const getMaxDate = () => {
    if (isStaff) return new Date()

    return maxDate || MAX_AV_DATE
  }

  useEffect(() => {
    if (avDate === null && policyAvDate) setAvDate(toDate(policyAvDate))
    else if (avDate && !policyAvDate) setAvDate(null)
    else {
      const a =
          avDate && typeof avDate === 'object'
            ? moment(avDate).format('YYYY-MM-DD')
            : (avDate ? `${avDate}` : '').split('T').shift(),
        p =
          policyAvDate && typeof policyAvDate === 'object'
            ? moment(policyAvDate).format('YYYY-MM-DD')
            : (policyAvDate ? `${policyAvDate}` : '').split('T').shift()

      if (a && p && /\d{4}-\d{2}-\d{2}/.test(a) && /\d{4}-\d{2}-\d{2}/.test(p) && a !== p)
        setAvDate(toDate(policyAvDate))
    }
  }, [avDate, policyAvDate])

  useEffect(() => {
    determineMinimumAvDate(enableBackdate)
  }, [policyId, enableBackdate])

  return (
    <UIDatePickerInput
      label={isEditPage ? 'Date Submitted To Carrier' : 'Enter Date To Carrier'}
      name='av_date'
      id='av_date'
      onChange={evt => onAvDateChange(evt.target.value)}
      required={true}
      showYearDropdown
      yearDropdownItemNumber={5}
      scrollableYearDropdown
      dateFormat='MM/dd/yyyy'
      maxDate={getMaxDate()}
      minDate={getMinDate()}
      selected={avDate}
      disabled={isDisabled()}
      value={avDate && typeof avDate === 'object' ? moment(avDate).format('MM/DD/YYYY') : ''}
      rules={{ required: true }}
      showValidity={SalesTrackerStore.showErrors}
      onValidityChange={validity => SalesTrackerStore.setValidity(0, 'av_date', validity.isValid)}
    />
  )
})
